export default __webpack_public_path__ + "static/media/Component5.ee3dbe71.jpg";